/**
 * First Light: a 3D, scored walk through MiMo-V2.6-Pro, one token's trip
 * round a dial of 70 blocks under a sky of the conversation's stars. three.js
 * is big, so the player loads on its own, only on pages that show it, and
 * never on the server.
 */
import dynamic from "next/dynamic";
import { CSS } from "./story/palette";

const Player = dynamic(() => import("./Player"), {
  ssr: false,
  loading: () => (
    <div
      className="not-prose my-10 relative left-1/2 -translate-x-1/2 w-[min(calc(100vw-2rem),64rem)] aspect-video rounded-xl border"
      style={{ background: CSS.zenith, borderColor: CSS.grid }}
    />
  )
});

export default function LongExposure() {
  return <Player />;
}
